import React from 'react'
import injectSheet from 'react-jss'
import styles from './works-table.styles'
import { Table, HeadCell } from 'pobble-components/dist/table'
import WorkEntry from './work-entry/work-entry.container'

const WorksTable = ({ classes, works, noWorks }) =>
  noWorks ? (
    <span>This moderation file doesn't have any works</span>
  ) : (
    <Table>
      <thead>
        <tr>
          <HeadCell className={classes.date}>Thumb</HeadCell>
          <HeadCell className={classes.date}>Date</HeadCell>
          <HeadCell className={classes.left}>Work</HeadCell>
        </tr>
      </thead>
      <tbody>
        {works.map((work, index) => (
          <WorkEntry key={work.index} id={work.id} />
        ))}
      </tbody>
    </Table>
  )

export default injectSheet(styles)(WorksTable)
